import React from 'react';
import { useDispatch } from 'react-redux';

import useSession from '../../hooks/useSession';
import DropDownSelector from 'views/widgets/DropDownSelector.jsx';
import { addMessage } from '../../messages/messageSlice';

export default function RolePicker(props) {

	const { sessionChanging, sessionChanged } = props;
	const { getSession, setSession, setPreference, persistPreferences } = useSession();
	const dispatch = useDispatch();
	let session = getSession();

	const roleSelected = (role) => {
		if (role.id == session.currentRole.id) return;
		sessionChanging();
		if (session.instance) setPreference("LAST_INSTANCE_FOR_ROLE_" + session.currentRole.id, session.instance.id);
		persistPreferences(true, () => { switchToRole(role); });
	};
	
	const switchToRole = (role) => {
		fetch(API_URL + "/api/session/role?id=" + role.id + "&org=" + session.organization.id, {
			method: 'PUT',
			credentials: 'include'
		}).then(function(response) {
			if (!response.ok) {
				throw Error(response.status);
			} 
			return response.json();
		}).then(function(newSession) {
			setSession(newSession, true);
			setPreference("LAST_ROLE_ORGANIZATION", newSession.currentRole.org_id);
			setPreference("LAST_ROLE_FOR_ORG_" + newSession.currentRole.org_id, newSession.currentRole.id);
			window.location.reload();
		}).catch(function(err) {
			sessionChanged();
			let errMsg = (err.message === '403') ? ("Unable to switch roles.") : ("Failed to switch roles, please contact Support.");
			dispatch(addMessage({ type: 'error', msg: errMsg }));
		});
	};

	return (
		<React.Fragment>
			<DropDownSelector	
				currentItem={session.currentRole}
				items={session.roles}
				itemSelected={roleSelected}
				description={"Role Selector; Selecting a new role will refresh your session."}
				{...props}
			/>
		</React.Fragment>
	);
}